import React, {useState} from 'react';

const FAQ = ({question, children}) => {
    const [opened, setOpened] = useState(false);
    const [effect, setEffect] = useState(false);

    return (
        <div className="bg-[rgba(0,_0,_0,_0.6)] rounded-[15px] p-6">
            <div className="flex place-items-center justify-between">
                <h1 className="text-[30px] w-[85%] lg:w-[90%]">{question}</h1>
                <div
                    className={`${effect && "hvr-push"} flex cursor-pointer rounded-full justify-center place-items-center w-[30px] h-[30px] bg-white`}
                    onClick={() => {
                        setOpened(!opened)
                        setEffect(true)
                    }}
                    onAnimationEnd={() => {
                        setEffect(false)
                    }}>
                    <span className="text-black text-[30px] select-none">{opened ? "-" : "+"}</span>
                </div>
            </div>
            <p className="text-[30px] ml-2 opacity-50 w-[80%]">
                {
                    opened && children
                }
            </p>
        </div>
    );
};

export default FAQ;